'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Tooltip } from '@stratascratch/ui';
import { Settings } from '@stratascratch/icons';
import './EditorButtons.css';
function EditorButtons(_a) {
    var { children = null, tooltips = [], className = '' } = _a, rest = __rest(_a, ["children", "tooltips", "className"]);
    const [areSettingsOpen, setAreSettingsOpen] = useState(false);
    const isArrayOfChildren = React.Children.count(children) > 1;
    return (_jsxs("div", { className: "EditorButtons__container", onMouseLeave: () => setAreSettingsOpen(false), children: [isArrayOfChildren && !areSettingsOpen && (_jsx("button", Object.assign({ type: "button", className: `EditorButtons__button EditorButtons__button-settings ${className}`, onClick: () => setAreSettingsOpen(true) }, rest, { children: _jsx(Settings, {}) }), "button-settings")), areSettingsOpen &&
                (isArrayOfChildren ? (React.Children.map(children, (child, index) => {
                    if (React.isValidElement(child)) {
                        return (_jsx("button", Object.assign({ type: "button", className: `EditorButtons__button EditorButtons__button-${index} ${className}` }, rest, { children: child }), child.key || `button-${Math.random()}`));
                    }
                    return null;
                })) : (_jsx("button", Object.assign({ type: "button", className: `EditorButtons__button EditorButtons__button-0 ${className}` }, rest, { children: children })))), isArrayOfChildren && !areSettingsOpen && (_jsx(Tooltip, { className: "EditorButtons__tooltip EditorButtons__tooltip-settings", text: "Settings", position: "left" }, "tooltip-settings")), isArrayOfChildren
                ? tooltips === null || tooltips === void 0 ? void 0 : tooltips.map((tooltip, index) => (_jsx(Tooltip, { className: `EditorButtons__tooltip EditorButtons__tooltip-${index}`, text: tooltip, position: "left" }, tooltip)))
                : tooltips &&
                    tooltips[0] && (_jsx(Tooltip, { className: "EditorButtons__tooltip EditorButtons__tooltip-0", text: tooltips[0], position: "left" }, tooltips[0]))] }));
}
export default EditorButtons;
//# sourceMappingURL=EditorButtons.js.map